module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"dialog":{"close":"Luk"}},"de":{"dialog":{"close":"Schließen"}},"fr":{"dialog":{"close":"Fermer"}},"nl":{"dialog":{"close":"Sluiten"}}}')
  delete Component.options._Ctor
}
